function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 22.5,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.941 17.999l-13.2 13.2-7.2-7.2",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "bevel"
});

const SvgOkCirlce = props => React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  fill: "none"
}, props), _ref, _ref2);

export default SvgOkCirlce;